module.exports = __webpack_public_path__ + "img/legal.3b76ebe8.svg";